import React from "react";
import { Person } from "@microsoft/mgt-react";
import { useLocation, useNavigate } from "react-router-dom";

interface ProfileProps {
  entraId?: string;
  name: string;
  designation: string;
  department: string;
  location: string;
  isSearching: boolean;
  searchQuery: string;
  profileShortCode: string;
  onSelect?: () => void; 
}

const Profile: React.FC<ProfileProps> = ({
  entraId,
  name,
  designation,
  department,
  location,
  isSearching,
  searchQuery,
  profileShortCode,
  onSelect
}) => {
  const navigate = useNavigate();
  const currentLocation = useLocation();
  const navState = currentLocation.state as { from?: string; query?: string };

  const redirectToProfile = (shortCode: string) => {
    navigate(`/profile/${shortCode}`, {
      state: {
        from: isSearching ? "search" : "home",
        query: isSearching
          ? searchQuery
            ? searchQuery
            : navState.query
          : null,
      },
    });

    if (onSelect) {
      onSelect();
    }
    
  };

  return (
    <div
      className="profile-card"
      onClick={() => redirectToProfile(profileShortCode)}
    >
      <div className="profile-left">
        <div
          className="profile-avatar mb-3"
          onClick={(e) => e.stopPropagation()}
        >
          {entraId ? (
            <Person
              userId={entraId}
              personCardInteraction="hover"
              showPresence={true}
              avatarSize="large"
            />
          ) : null}
        </div>
        <div className="profile-info">
          <span className="profile-name mb-2">{name}</span>
          <span className="profile-title">{designation}</span>
        </div>
      </div>
      <div className="profile-right">
        <span className="profile-meta">{department}</span>
        <span> | </span>
        <span className="profile-meta">{location}</span>
      </div>
    </div>
  );
};

export default Profile;
